module.exports = __webpack_public_path__ + "img/blueBoxBttomRight.2317000c.svg";